import { create } from 'zustand';

type LayoutFlags = { showInsights: boolean; showUpgrade: boolean };
type LayoutState = LayoutFlags & {
  toggle: (key: keyof LayoutFlags) => void;
  /** Off-canvas sidebar on narrow viewports; never persisted. */
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
};

const KEY = 'syncra.layout';
const defaults: LayoutFlags = { showInsights: true, showUpgrade: true };

function load(): LayoutFlags {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...defaults, ...(JSON.parse(raw) as Partial<LayoutFlags>) } : defaults;
  } catch {
    return defaults;
  }
}

function save(flags: LayoutFlags): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(flags));
  } catch {
    /* per-viewer convenience only */
  }
}

/** Configurable shell props from the design: insights side panel and upgrade block. */
export const useLayout = create<LayoutState>((set, get) => ({
  ...load(),
  sidebarOpen: false,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggle: (key) => {
    const next = { showInsights: get().showInsights, showUpgrade: get().showUpgrade, [key]: !get()[key] };
    save(next);
    set(next);
  }
}));
